import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage';
import Hizmetlerimiz from './components/Hizmetlerimiz';
import Projelerimiz from './components/Projelerimiz';
import Iletisim from './components/Iletisim';
import LogoSplash from './components/LogoSplash';

function AppContent() {
  const [showSplash, setShowSplash] = useState(true);
  const location = useLocation();
  const [hasShownSplash, setHasShownSplash] = useState(false);

  useEffect(() => {
    // Sadece ana sayfada ve ilk yüklemede splash göster
    if (location.pathname === '/' && !hasShownSplash) {
      setShowSplash(true);
    } else {
      setShowSplash(false);
    }
  }, [location.pathname, hasShownSplash]);

  const handleSplashComplete = () => {
    setShowSplash(false);
    setHasShownSplash(true);
  };

  return (
    <>
      {showSplash && <LogoSplash onComplete={handleSplashComplete} />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/hizmetlerimiz" element={<Hizmetlerimiz />} />
        <Route path="/projelerimiz" element={<Projelerimiz />} />
        <Route path="/iletisim" element={<Iletisim />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

